import dateFormat from "dateformat";
// return the time differance.
export const getParsedDate = (date) => {
  const currentDate = new Date();
  const targetDate = new Date(date);

  const utc1 = Date.UTC(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );
  const utc2 = Date.UTC(
    targetDate.getFullYear(),
    targetDate.getMonth(),
    targetDate.getDate()
  );
  const daysDiff = Math.abs(Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24)));

  if (daysDiff > 7) {
    return dateFormat(date, "mmm dd, yyyy");
  }

  const oldDate = String(date).split("T");
  const oldDay = String(oldDate[0]).split("-");
  const oldTime = String(oldDate[1]).split(":");
  const LastDate = [
    parseInt(oldDay[0]),
    parseInt(oldDay[1]),
    parseInt(oldDay[2]),
    parseInt(oldTime[0]),
    parseInt(oldTime[1]),
    parseInt(oldTime[2]),
  ];

  const day = currentDate.getUTCDate() - LastDate[2];
  const hours = currentDate.getUTCHours() - LastDate[3];
  const minutes = currentDate.getUTCMinutes() - LastDate[4];

  if (day < 0) {
    return dateFormat(date, "mmm dd, yyyy");
  }

  const unit = [];
  day === 0
    ? hours === 0
      ? unit.push(
          minutes > 1 ? minutes : "< 1 ",
          minutes > 1 ? "minutes" : "minute"
        )
      : unit.push(hours, hours > 1 ? "hours" : "hour")
    : unit.push(day, day > 1 ? "days" : "day");

  return unit.join(" ") + " ago";

};

// returns the Name intial
export const getIntials = (user) => {
  if (
    user &&
    user.firstName &&
    user.lastName &&
    user.firstName.length > 0 &&
    user.lastName.length > 0
  ) {
    return "".concat(
      user.firstName[0].toUpperCase(),
      user.lastName[0].toUpperCase()
    );
  }
  return "AA";
};

export const getName = (user) => {
  const firstName =
    user.firstName.slice(0, 1).toUpperCase() +
    user.firstName.slice(1, user.firstName.length);
  const lastName =
    user.lastName.slice(0, 1).toUpperCase() +
    user.lastName.slice(1, user.lastName.length);
  return "".concat(firstName, " ", lastName);
};

export const getCapitals = (str) => {
  const words = str.split(" ");
  return words
    .map((word) => {
      return word[0].toUpperCase() + word.substring(1);
    })
    .join(" ");
};

// return the time differance.
export const getParsedTime = (date) => {
  const currentDate = new Date();
  const targetDate = new Date(date);

  const hours = Math.round(Math.abs(currentDate - targetDate) / (1000 * 60 * 60));
  const minutes = Math.round(Math.abs(currentDate - targetDate) / (1000 * 60));

  if (hours >= 1) {
    return dateFormat(date, "h.MM TT");
  }

  const unit = [];
  if (hours === 0 && minutes === 0) {
    return "Just Now";
  }
  hours === 0 ? unit.push(minutes, "m") : unit.push(hours, "h");
  return unit.join("") + " ago";

};